import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-stretch" }
const _hoisted_2 = { class: "flex p-cell note items-center justify-end" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"px-page pt-95 pb-20 flex gap-12\"><div class=\"flex items-center justify-center rounded-base loading-animation\" style=\"width:100px;height:100px;\"></div><div class=\"flex flex-col flex-grow gap-5\"><div class=\"loading-animation rounded-sm\" style=\"height:51px;width:70%;\"></div><div class=\"loading-animation rounded-sm\" style=\"height:29px;width:20%;\"></div></div></div>", 1)
const _hoisted_4 = { class: "px-page flex flex-col mt-82 gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Profile = _resolveComponent("Profile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Profile)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "loading-animation rounded-sm",
        style: _normalizeStyle({ height: '51px', width: 40 + 50 * Math.random() + '%' })
      }, null, 4),
      _createElementVNode("div", {
        class: "loading-animation rounded-sm",
        style: _normalizeStyle({ height: '29px', width: 20 + 30 * Math.random() + '%' })
      }, null, 4),
      _createElementVNode("div", {
        class: "loading-animation rounded-sm my-12",
        style: _normalizeStyle({ height: '240px', width: 50 + 30 * Math.random() + '%' })
      }, null, 4)
    ])
  ]))
}